<template>
    <div>
        <v-row justify="center" class="bg-color-teal-900">
            <v-col cols="4" sm="4">
                <v-container>
                        <div class="body-text text-white mt-4">
                            <p class="text-h4 font-weight-light">
                                <LanguagePlaceholder is-html default-text="Partner Performance" />
                            </p>
                            <br />
                            <p >
                                <b>WHAT is this report: </b>
                                The Partner Performance report shows you the current performance of your partners. The data in this report runs approximately 2 weeks behind current date.
                                <br /><br />
                                <b>HOW do you use it: </b>
                                Use this report to drive sign-ups on the RISE portal. Reach out to partners who haven't signed up and show them how much they are missing out on by not signing up.
                            </p>
                            <!-- <p >
                                <b>WHAT is this report: </b>
                                The Partner Performance report shows you the current performance of your partners, whether or not they have accepted the RISE Terms and Conditions, and the value of the rewards they can potentially earn. The data in this report runs approximately 2 weeks behind current date.
                                <br /><br />
                                <b>HOW do you use it: </b>
                                Use this report to drive sign-ups on the RISE portal. Reach out to partners who haven't signed up and show them how much they are missing out on by not signing up. You can also this report to see the split of sales from your partners should you need to drive specific portfolio sales.
                            </p> -->
                            <PleaseNote></PleaseNote>
                        </div>
                    </v-container>
            </v-col>
            <v-col cols="8" sm="8">
                <v-row>
                    <v-container>
                        <v-row class="my-2 mr-2">
                            <v-col cols="12" sm="6">
                                <div>
                                    <v-select class="text-white" v-model="selectedQuarter"
                                        @update:modelValue="changeQuarter" :items="quarters" variant="outlined"
                                        aria-label="Select Incentive Period">
                                        <template v-slot:label>
                                            <LanguagePlaceholder is-html default-text="Select Incentive Period" />
                                        </template>
                                    </v-select>
                                </div>

                            </v-col>
                            <v-col cols="12" sm="6">
                                <div>
                                    <v-select clearable @click:clear="clickClearCountry" :items="countries"
                                        return-object v-model="selectedCountry" class="text-white"
                                        @update:modelValue="changeCountry" item-title="country" item-value="country"
                                        variant="outlined"
                                        aria-label="Select Location">
                                        <template v-slot:label>
                                            <LanguagePlaceholder is-html default-text="Select Location" />
                                        </template>
                                    </v-select>
                                </div>

                            </v-col>
                        </v-row>
                        <v-row class="my-2">
                            <v-col cols="12" sm="6">
                                <div>
                                    <v-select clearable @click:clear="clickClearDistributor" class="text-white"
                                        v-model="selectedDistributor" return-object
                                        @update:modelValue="changeDistributor" item-title="distributorName"
                                        item-value="distiId" :items="distributors" variant="outlined"
                                        aria-label="Select Distributor">
                                        <template v-slot:label>
                                            <LanguagePlaceholder is-html default-text="Select Distributor" />
                                        </template>
                                    </v-select>
                                </div>

                            </v-col>
                            <v-col cols="12" sm="6">


                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col cols="12" sm="6" class="">
                                <v-select clearable :items="partners" v-model="selectedPartner" class="text-white"
                                    item-title="partnerName" item-value="partnerId" variant="outlined"
                                    aria-label="Select Partner">
                                    <template v-slot:label>
                                        <LanguagePlaceholder is-html default-text="Select Partner" />
                                    </template>
                                </v-select>

                            </v-col>
                            <v-col cols="12" sm="6">
                                <div>
                                    <v-switch @change="changeIncludePotentialPartners" class=" ml-4 text-white"
                                        v-model="includePotentialPartners" color="amber">
                                        <template v-slot:label>
                                            <LanguagePlaceholder is-html
                                                default-text="Include all potential partners" />
                                        </template>
                                    </v-switch>
                                </div>
                            </v-col>

                        </v-row>
                        <v-row class="my-2 gap-2" align="center">
                            <v-col cols="12" sm="6">
                                <v-btn color="white" variant="outlined" :disabled="!canSubmitReport" @click="clickSubmit"
                                    ><LanguagePlaceholder default-text="Submit" /></v-btn>
                                <v-btn prepend-icon="mdi-download" @click="downloadFile" color="white" variant="outlined" class="ml-4" aria-label="Download Report"><LanguagePlaceholder default-text="Download" /></v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="">




                            </v-col>
                        </v-row>
                    </v-container>


                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>

        <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-container>
                <v-text-field v-model="searchString" label="Filter" prepend-inner-icon="mdi-filter-outline"
                    variant="outlined" hide-details single-line></v-text-field>
                <v-data-table items-per-page="50" :headers="headers" :items="reportData" :search="searchString"
                    class="v-data-table">
                    <template v-slot:item.pcDisplayPeripheral="{ item }">
                        {{ $filters.currencyUSD(item.pcDisplayPeripheral) }}
                    </template>
                    <template v-slot:item.server="{ item }">
                        {{ $filters.currencyUSD(item.server) }}
                    </template>
                    <template v-slot:item.storage="{ item }">
                        {{ $filters.currencyUSD(item.storage) }}
                    </template>
                    <template v-slot:item.bonus="{ item }">
                        {{ $filters.currencyUSD(item.bonus) }}
                    </template>
                    <template v-slot:item.progressGraph="{ item }">
                        <v-btn icon="mdi-chart-bar" @click="getMyPerformanceData(item.partnerAffinityId
                                                                                , item.partnerName
                                                                                , item.pdpUnits
                                                                                , item.serverUnits
                                                                                , item.storageUnits
                                                                                , item.pdpTotalUnits
                                                                                , item.serverTotalUnits
                                                                                , item.storageTotalUnits
                                                                                )" variant="text" />
                    </template>
                </v-data-table>
            </v-container>
        </v-row>


    <!-- <v-dialog v-model="showDataDelayNotice" width="650" scrollable>
        <v-card>
            <v-toolbar color="#0d2155">
                <v-toolbar-title><LanguagePlaceholder default-text="Important Notice" /></v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-4">
                <p class="my-2 general-text tx-font-bolder">
                    <LanguagePlaceholder default-text="Please note that there is a delay in the FY27Q2 Performance data update on RISE, we will inform you as soon as it is available." />
                </p>
            </v-card-text>
            <v-card-actions class="border-t-thin">
                <v-spacer></v-spacer>
                <v-btn @click="showDataDelayNotice = false" width="100" color="#055699" variant="elevated"><LanguagePlaceholder default-text="Close" /></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> -->

    <v-dialog v-model="showRewardProgress" width="100%" scrollable transition="dialog-bottom-transition" fullscreen>
      <v-card>
          <v-toolbar>
              <v-toolbar-title>{{rewardPartnerName}} ({{ rewardPartnerId }})</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  icon="mdi-close"
                  @click="closeRewardsDialog"
               ></v-btn>
          </v-toolbar>
          <v-card-text class="pa-4">
            <div class="d-flex flex-wrap flex-row ga-10 justify-center">
                <PartnerRewardsProgress 
                    title="PCs+Displays+Peripherals" 
                    subTitleLine1="Threshold 1    1.2x Rewards"
                    subTitleLine2="Threshold 2    1.3x Rewards"
                    subTitleLine3="Threshold 3    1.4x Rewards"
                    subTitleLine4="Threshold 4    1.5x Rewards"
                    subTitleLine5="Threshold 5    1.6x Rewards"
                    :labels="['Threshold 5  400 units', 'Threshold 4  250 units', 'Threshold 3  160 units', 'Threshold 2    80 units', 'Threshold 1    30 units']" 
                    :units="rewardPdpUnits"
                    :totalUnits="rewardPdpTotalUnits"
                    :limit1="30" 
                    :limit2="80" 
                    :limit3="160" 
                    :limit4="250" 
                    :limit5="400" 
                    :reward-loading="false"
                ></PartnerRewardsProgress>
                <PartnerRewardsProgress 
                    title="SERVER+" 
                    subTitleLine1="Threshold 1    1.2x Rewards"
                    subTitleLine2="Threshold 2    1.3x Rewards"
                    subTitleLine3="Threshold 3    1.4x Rewards"
                    subTitleLine4="Threshold 4    1.5x Rewards"
                    subTitleLine5="Threshold 5    1.6x Rewards"
                    :labels="['Threshold 5  21 units', 'Threshold 4  17 units', 'Threshold 3  13 units', 'Threshold 2    9 units', 'Threshold 1    5 units']" 
                    :units="rewardServerUnits"
                    :totalUnits="rewardServerTotalUnits"
                    :limit1="5" 
                    :limit2="9" 
                    :limit3="13" 
                    :limit4="17" 
                    :limit5="21" 
                    :reward-loading="false"
                ></PartnerRewardsProgress>
                <PartnerRewardsProgress 
                    title="STORAGE+" 
                    subTitleLine1="Threshold 1    1.2x Rewards"
                    subTitleLine2="Threshold 2    1.3x Rewards"
                    subTitleLine3="Threshold 3    1.4x Rewards"
                    subTitleLine4="Threshold 4    1.5x Rewards"
                    subTitleLine5="Threshold 5    1.6x Rewards"
                    :labels="['Threshold 5  13 units', 'Threshold 4  11 units', 'Threshold 3   8 units', 'Threshold 2   5 units', 'Threshold 1   2 units']" 
                    :units="rewardStorageUnits"
                    :totalUnits="rewardStorageTotalUnits"
                    :limit1="2"
                    :limit2="5"
                    :limit3="8"
                    :limit4="11"
                    :limit5="13"
                    :reward-loading="false"
                ></PartnerRewardsProgress>
            </div>  
          </v-card-text>
          <v-card-actions class="border-t-thin">
              <v-btn @click="closeRewardsDialog" width="100">Close</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>

</div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useRegistrationStore } from '@/stores/registration'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useExcelStore } from '@/stores/excel'
import PleaseNote from '@/components/PleaseNote.vue'
import PartnerRewardsProgress from '@/components/PartnerRewardsProgress.vue'


const systemStore = useSystemStore()
const registrationStore = useRegistrationStore()
const excelStore = useExcelStore()

const quarters = ref([])
const selectedQuarter = ref('')
const selectedCountry = ref('')
const selectedDistributor = ref(null)
const selectedPartner = ref(null)

const includePotentialPartners = ref(false)
const affinityId = ref(0)
const countries = ref([])
const distributors = ref([])
const partners = ref([])
const reportData = ref([])
const searchString = ref('')

const showDataDelayNotice = ref(true)
const showRewardProgress = ref(false)
const rewardPartnerName = ref('')
const rewardPartnerId = ref(0)
const rewardPdpUnits = ref(0)
const rewardServerUnits = ref(0)
const rewardStorageUnits = ref(0)
const rewardPdpTotalUnits = ref(0)
const rewardServerTotalUnits = ref(0)
const rewardStorageTotalUnits = ref(0)

const headers = ref([
    { title: "Rewards Chart", key: "progressGraph",headerProps: { class: 'header-style' } },
    { title: "Partner Id", value: "partnerAffinityId", sortable: true, headerProps: { class: 'header-style' } },
    { title: "Partner Name", value: "partnerName", sortable: true, headerProps: { class: 'header-style' } },
    { title: "Location", value: "country", headerProps: { class: 'header-style' } },
    { title: "PCs+Displays+Peripherals", value: "pcDisplayPeripheral", sortable: true, headerProps: { class: 'header-style' } },
    { title: "Server+", value: "server", sortable: true, headerProps: { class: 'header-style' } },
    { title: "Storage+", value: "storage", sortable: true, headerProps: { class: 'header-style' } },
    { title: "Bonus", value: "bonus", sortable: true, headerProps: { class: 'header-style' } },
    { title: "IN/OUT RISE", value: "inOutRISE", sortable: true, headerProps: { class: 'header-style' } },
]);

const isCurrentUserDistributor = computed(() => {
    if (systemStore.userDetail.userType === 'Distributor') {
        return true
    } else {
        return false
    }
})

const canSubmitReport = computed(() => {
    var distiId = selectedDistributor.value == null ? 0 : selectedDistributor.value.distiId

    // if (systemStore.systemView == 'Distributor') {
    //     if (selectedQuarter.value != '' && selectedCountry.value != null && selectedCountry.value !== undefined) {
    //         if (isCurrentUserDistributor.value === true && distiId === 0) {
    //             return false
    //         } else {
    //             return true
    //         }
    //     } else {
    //         return false
    //     }
    // } else if (systemStore.systemView == 'Dell' || systemStore.systemView == 'TIC') {
    //     return true
    // }

    return true
})

onMounted(() => {
    affinityId.value = systemStore.userDetail.affinityId

    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentQuarters === true)
                .map(q => q.quarter)

            selectedQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter

            systemStore.getPartnerPerformanceCountries(selectedQuarter.value).then(result => {
                countries.value = result.responseData
                selectedCountry.value = ''
            })
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })
})

const getMyPerformanceData = (aid, name, pdpUnits, serverUnits, storageUnits, pdpTotalUnits, serverTotalUnits, storageTotalUnits) => {
    showRewardProgress.value = true
    rewardPartnerId.value = aid
    rewardPartnerName.value = name
    rewardPdpUnits.value = pdpUnits
    rewardServerUnits.value = serverUnits
    rewardStorageUnits.value = storageUnits
    rewardPdpTotalUnits.value = pdpTotalUnits
    rewardServerTotalUnits.value = serverTotalUnits
    rewardStorageTotalUnits.value = storageTotalUnits
}

const closeRewardsDialog = () => {
    showRewardProgress.value = false
    rewardPartnerId.value = 0
    rewardPartnerName.value = ''
    rewardPdpUnits.value = 0
    rewardServerUnits.value = 0
    rewardStorageUnits.value = 0
    rewardPdpTotalUnits.value = 0
    rewardServerTotalUnits.value = 0
    rewardStorageTotalUnits.value = 0
}

const downloadFile = () => {
    if (reportData.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(reportData.value, 'DistributorPartnerPerformanceDocument').catch(error => {
        console.log('Generate In Memory Excel Document - DistributorPartnerPerformanceDocument', error)
    })
}

const changeIncludePotentialPartners = () => {
    searchPartners()
}

const clickClearCountry = () => {
    selectedCountry.value = null
    selectedDistributor.value = null
    partners.value = []
}

const clickClearDistributor = () => {
    selectedDistributor.value = null
    partners.value = []
}

const changeQuarter = () => {
    selectedCountry.value = null
    selectedDistributor.value = null
    selectedPartner.value = null
}

const changeDistributor = () => {
    selectedPartner.value = null
    partners.value = []

    if (selectedDistributor.value == null) {
        return
    }

    searchPartners()

}

const searchPartners = () => {
    if (isCurrentUserDistributor.value === false && selectedDistributor.value == null) {
        return
    }

    // var distiId = isCurrentUserDistributor.value === true ? affinityId.value : selectedDistributor.value.distiId

    if (includePotentialPartners.value === false) {
        systemStore.getPartnerPerformancePartners(selectedQuarter.value, selectedCountry.value, selectedDistributor.value.distiId).then(result => {
            partners.value = result.responseData
        })
    } else {
        systemStore.getPartnerPerformanceAllPotentialPartners(selectedQuarter.value, selectedCountry.value, selectedDistributor.value.distiId).then(result => {
            partners.value = result.responseData
        })
    }
}

const changeCountry = () => {
    selectedDistributor.value = null
    selectedPartner.value = null

    // if (isCurrentUserDistributor.value) {
    //     searchPartners()
    //     return
    // }


    if (selectedCountry.value === null) {
        return
    }
    systemStore.getPartnerPerformanceDistributors(selectedQuarter.value, selectedCountry.value).then(result => {
        distributors.value = result.responseData

        if (distributors.value.length === 1) {
            selectedDistributor.value = distributors.value[0]
            searchPartners()
        }
    }).catch(error => {
        console.log(error)
    })
}

// const changeQuarter = () => {
//     systemStore.getPartnerPerformanceCountries(selectedQuarter.value).then(result => {
//         countries.value = result.responseData
//         selectedCountry.value = ''
//     })
// }

const clickSubmit = () => {
    var q = selectedQuarter.value
    var cnt = selectedCountry.value
    var dst = selectedDistributor.value
    var prt = selectedPartner.value

    getReportData()
}

const getReportData = () => {
    var distiId = selectedDistributor.value == null ? 0 : selectedDistributor.value.distiId
    var accepted = !includePotentialPartners.value
    selectedCountry.value = selectedCountry.value == null ? '' : selectedCountry.value

    systemStore.getPartnerPerformanceReport(selectedQuarter.value, selectedCountry.value, distiId, selectedPartner.value, accepted).then(result => {
        reportData.value = result.responseData.reportData
    }).catch(error => {
        console.log('distributor dashboard, get data', error)
    })
}


</script>


<style>
.header-style {

    /* background-color: #012a4b; */
    background-color: #004D40;
    color: white;
}

.v-data-table tbody tr:nth-child(even) {
    background-color: #e0e6ec;
    color: #202520;
}

.v-data-table tbody tr:nth-child(odd) {
    background-color: whitesmoke;
    color: #202520;
}
</style>
